export default "__VITE_ASSET__DrdcX0DV__"